// frontend/src/apps/los/components/BankAccountNumberInput/BankAccountNumberInput.tsx
import React, { useCallback } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface BankAccountNumberInputProps {
  value?: any;
  onChange?: (value: any) => void;
  disabled?: boolean;
}

const BankAccountNumberInput: React.FC<BankAccountNumberInputProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const currentValue = value?.beneficiary_account_no || '';

  const handleChange = useCallback((val: string) => {
    // Only allow digits
    const sanitized = val.replace(/\D/g, '');
    if (onChange) {
      onChange({ beneficiary_account_no: sanitized });
    }
  }, [onChange]);

  const handleBlur = () => {
    // Validation on blur
    if (currentValue && (currentValue.length < 9 || currentValue.length > 18)) {
      // Validation will be handled by the form/page level
    }
  };

  return (
    <div className="space-y-1.5">
      <Label htmlFor="bank_account_number">
        Bank Account Number <span className="text-red-500">*</span>
      </Label>
      <Input
        id="bank_account_number"
        type="text"
        placeholder="Enter account number (9-18 digits)"
        value={currentValue}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={handleBlur}
        disabled={disabled}
        maxLength={18}
        className="w-full"
      />
      <p className="text-xs text-gray-500">Enter your bank account number (9-18 digits)</p>
    </div>
  );
};

export default BankAccountNumberInput;
